import { gql } from '@apollo/client';

export const GET_COURSE_TAGS_BATCH = gql`
  query GetCourseTagsBatch($where: OelTaggingObjecttagBoolExp!) {
    oelTaggingObjecttag(where: $where) {
      value
      objectId
      taxonomyId
    }
  }
`;
